import { render } from "./Chevron.vue?vue&type=template&id=9d160ae8"
const script = {}
script.render = render

export default script